import { create } from 'zustand';

import {
  apiListDatasetsForProfile,
} from '../api/datasetFetch';
import type { ProfileDatasetSection } from '../types/datasetTypes';

export type ReloadProfileDatasetsOptions = {
  canLoad?: boolean;
  onError?: (message: string) => void;
};

type ProfileDatasetsState = {
  ownSections: ProfileDatasetSection[];
  sharedSections: ProfileDatasetSection[];
  isLoading: boolean;
  isLoaded: boolean;
  reloadDatasets: (options?: ReloadProfileDatasetsOptions) => Promise<void>;
  resetProfileDatasets: () => void;
};

const emptyState = {
  ownSections: [] as ProfileDatasetSection[],
  sharedSections: [] as ProfileDatasetSection[],
  isLoading: false,
  isLoaded: false,
};

export const useProfileDatasetsStore = create<ProfileDatasetsState>((set) => ({
  ...emptyState,

  reloadDatasets: async (options = {}) => {
    const { canLoad = true, onError } = options;

    if (!canLoad) {
      set({ ...emptyState, isLoaded: true });
      return;
    }

    set({ isLoading: true });
    try {
      const data = await apiListDatasetsForProfile();
      set({
        ownSections: data.own,
        sharedSections: data.shared,
        isLoading: false,
        isLoaded: true,
      });
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load datasets';
      onError?.(message);
      set({
        ownSections: [],
        sharedSections: [],
        isLoading: false,
        isLoaded: true,
      });
    }
  },

  resetProfileDatasets: () => set(emptyState),
}));
